export const ALL_VALUES_OPTION = { value: '*', label: '' };
